var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuspendModalIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ModalIcons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9337 50.9261L15.9348 51.0691C11.2222 51.0904 9.31824 47.8019 11.682 43.7251L27.843 15.852C30.2068 11.7752 34.0244 11.7837 36.371 15.8712L52.2196 43.4872C54.5652 47.5747 52.6462 50.9048 47.9337 50.9261ZM31.907 40.4408C30.7284 40.4408 29.7737 41.3965 29.7737 42.5741C29.7737 43.7517 30.7294 44.7075 31.907 44.7075C33.0846 44.7075 34.0404 43.7517 34.0404 42.5741C34.0404 41.3965 33.0846 40.4408 31.907 40.4408ZM31.907 38.3075C33.0846 38.3075 34.0404 37.3517 34.0404 36.1741V27.6408C34.0404 26.4632 33.0846 25.5075 31.907 25.5075C30.7294 25.5075 29.7737 26.4632 29.7737 27.6408V36.1741C29.7737 37.3528 30.7294 38.3075 31.907 38.3075Z",
    fill: "#8A5C00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuspendModalIcon);
export default __webpack_public_path__ + "static/media/SuspendModalIcon.14a2e759d55789a3971d0b80823cea31.svg";
export { ForwardRef as ReactComponent };